import React from "react";

const Reddit = () => {
  return (
    <>
      <h1 className="mb-2 mt-20 text-3xl">Reddit sidebar</h1>

      {/* REDDIT SIDE BAR */}
      <div className="mt-4 max-w-md rounded-md bg-gray-600 overflow-hidden text-gray-50 pb-5 shadow">
        <div className="grid grid-cols-12 p-5 font-light text-white text-lg cursor-pointer bg-gradient-to-r from-green-400 to-blue-600">
          <img
            className="col-span-2 m-0"
            style={{ height: 50 }}
            src="https://www.redditstatic.com/desktop2x/img/discovery/yoga-snoo.png"
          />
          <div className="col-span-10">
            Fitness communities that know how to do it
          </div>
        </div>
        <div>
          <div className="text-gray-200 cursor-pointer">
            <div className="border-b border-gray-400 px-5 py-2">
              r/livingdaybyday
            </div>
            <div className="border-b border-gray-400 px-5 py-2">
              r/showerthought
            </div>
            <div className="border-b border-gray-400 px-5 py-2">
              r/verynicenaming
            </div>
            <div className="px-5 py-2">r/lol</div>
          </div>
          <div className="p-4">
            <button className="bg-indigo-400 hover:bg-indigo-300 text-sm transition-colors duration-500 rounded-md p-2 w-full focus:outline-none">
              VIEW THEM ALL
            </button>
          </div>
          <div className="flex px-4">
            <div className="px-4 py-2 bg-gray-500 rounded-lg mr-3 cursor-pointer transition-colors hover:bg-gray-400">
              Text
            </div>
            <div className="px-4 py-2 bg-gray-500 rounded-lg mr-3 cursor-pointer transition-colors hover:bg-gray-400">
              Another
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reddit;
